import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  RequestResult,
  SagaIterator,
  assertTotalSchema,
  call,
  createDoRequestAction,
  debug,
  put,
  request,
  takeEvery,
  v,
} from '../../lib'
import {doPROJECT_SETTINGS_LIST_SET, doREQUEST_COMPLETE, doREQUEST_ERROR} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH = 'REQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH'
export const doREQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH = createDoRequestAction(
  REQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH,
)

export const requestIdentityProjectSettingsListFetchActionCreators = {
  doREQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH,
}

interface Payload {
  type: string
  payload: {
    requestId: string
  }
  setRequestResult: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestIdentityProjectSettingsListFetch({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestIdentityProjectSettingsListFetch')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/identity-project-settings-list-fetch`,
    accessToken,
    data: {},
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/identity-project-settings-list-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROJECT_SETTINGS_LIST_SET([...result.payload]))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* identityProjectSettingsListFetchSaga() {
  yield takeEvery(REQUEST_IDENTITY_PROJECT_SETTINGS_LIST_FETCH, requestIdentityProjectSettingsListFetch)
}
